// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OuIv","question":"styles_question__3ikOS","description":"styles_description__13AIb"};